import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Footer } from "../../Components/Footer/footer";
import { useNavigate, useLocation } from "react-router-dom";
import "./style.css";

interface Leader {
  name: string;
  role: string;
}

interface Organization {
  id: string;
  name: string;
  sector: string;
  is_sanitas: boolean;
  has_ccm: boolean;
  contact: {
    leaders: Leader[];
    phone: string;
    email: string;
    address: string;
  };
}

export function OrganizatiiMembrePage() {
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchData = async () => {
      const ref = doc(db, "site_content", "member_organizations");
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const rawOrgs = snap.data().organizations || [];
        // Normalize schema: dacă există încă vechiul leader_name
        const norm: Organization[] = rawOrgs.map((o: any) => ({
          id: o.id,
          name: o.name,
          sector: o.sector,
          is_sanitas: o.is_sanitas,
          has_ccm: o.has_ccm,
          contact: {
            leaders:
              o.contact?.leaders?.length > 0
                ? o.contact.leaders
                : o.contact?.leader_name
                ? [{ name: o.contact.leader_name, role: "" }]
                : [],
            phone: o.contact?.phone || "",
            email: o.contact?.email || "",
            address: o.contact?.address || "",
          },
        }));
        setOrganizations(norm);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="page-container">
      <Navbar />
      <div className="page-content">
        <h1>Organizații Membre</h1>
        <div className="org-grid">
          {organizations.map((org) => (
            <div key={org.id} className="org-card">
              <h3>{org.name}</h3>
              <p><strong>Sector:</strong> {org.sector}</p>
              <p><strong>Organizație Sanitas:</strong> {org.is_sanitas ? "DA" : "NU"}</p>
              <p><strong>Contract CCM:</strong> {org.has_ccm ? "DA" : "NU"}</p>

              <div className="leaders-section">
                <strong>Lideri:</strong>
                {org.contact.leaders.length > 0 ? (
                  <ul className="leaders-list">
                    {org.contact.leaders.map((ldr, i) => (
                      <li key={i}>
                        {ldr.name}
                        {ldr.role && <span className="leader-role"> – {ldr.role}</span>}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="no-leaders">Niciun lider specificat</p>
                )}
              </div>

              <button
                className="details-btn"
                onClick={() => {
                  const searchParams = new URLSearchParams(location.search);
                  const adminParam = searchParams.get("admin") === "true" ? "?admin=true" : "";
                  navigate(`/organizatii/${org.id}${adminParam}`);
                }}
              >
                Detalii organizație
              </button>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
